<template>
  <template v-for="font in fonts" :key="font.name">
    <span :class="font.name"></span>
  </template>
  <div v-if="isInit" class="d-flex-row-rev gravestone-column-container">
    <div class="conf-col-left" v-if="activeStep == 0">
      <DesignStep
      :chooseStep="chooseStep"

      :orientation="orientation"
      :setOrientation="setOrientation"

      :gravestones="gravestones"
      :selectGravestone="selectGravestone"
      :selectedGravestone="selectedGravestone"

      :withboard="withboard"
      :selectWithboard="selectWithboard"

      :surfacetreatments="surfacetreatments"
      :selectSurfacetreatment="selectSurfacetreatment"
      :selectedSurfacetreatment="selectedSurfacetreatment"

      :edgetreatments="edgetreatments"
      :selectEdgetreatment="selectEdgetreatment"
      :selectedEdgetreatment="selectedEdgetreatment"

      :stonesizes="stonesizes"
      :selectStonesize="selectStonesize"
      :selectedStonesize="selectedStonesize"

      :decors="decors"
      :selectedDecors="selectedDecors"
      :addDecor="addDecor"
      :deleteDecor="deleteDecor"
      :flipDecor="flipDecor"

      :fonts="fonts"
      :selectedFont="selectedFont"
      :selectFont="selectFont"

      :selectedTexts="selectedTexts"
      :addText="addText"
      :updateText="updateText"

      :stonetypes="stonetypes"
      :selectedStonetype="selectedStonetype"
      :selectStonetype="selectStonetype"

      :inscriptiondesigns="inscriptiondesigns"
      :selectedInscriptiondesign="selectedInscriptiondesign"
      :selectInscriptiondesign="selectInscriptiondesign"

      :colors="colors"
      :selectedDecorColor="selectedDecorColor"
      :selectedTextColor="selectedTextColor"
      :selectColor="selectColor"

      :reserverows="reserverows"
      :updateReserverows="updateReserverows"

      :accessories="accessories"
      :selectedAccessories="selectedAccessories"
      :selectAccessories="selectAccessories"
      :deleteAccessorie="deleteAccessorie"

      :percentageIncrease="percentageIncrease"
      />
    </div>
    <div class="conf-col-left" v-if="activeStep == 1">
      <OrderStep :value="customer" :errors="customer_errors" :setImages="setImages" />
    </div>
    <div class="conf-col-right">
      <div class="design-choice">
        <div class="d-flex-col">
          <div class="text-center flex-center-center" style="position: relative;width: inherit;" ref="container">
            <span class="stone-size-display">Bredd: {{ selectedStonesize.width }} cm</span>
            <span class="stone-size-display side">Höjd: {{ selectedStonesize.height }} cm</span>
            <v-stage ref="stage" :config="stageSize" @mousedown="handleStageMouseDown" @touchstart="handleStageMouseDown" @touchend="handleStageMouseUp" @mouseup="handleStageMouseUp">
              <v-layer ref="layer">
                <v-image ref="canvasGravestone" :config="{
                  x: 0,
                  y: 0,
                  width: stageSize.width,
                  height: stageSize.height,
                  image: canvasBackgroundImg,
                  type: 'gravestone'
                }">
                </v-image>
                <v-text v-for="item in selectedTexts" :ref="item.name" :key="item.id" :config="item" @transform="handleTransformEnd">
                </v-text>
                <v-rect v-for="item in selectedDecors" :ref="item.name" :key="item.id" :config="item" @transformend="handleTransformEnd" />
                <v-transformer ref="transformer" :config="{ flipEnabled: false, enabledAnchors: ['top-left', 'top-right', 'bottom-left', 'bottom-right']}" />
                <v-transformer ref="transformerText" :config="{flipEnabled: false, rotateEnabled: false, enabledAnchors: []}" />
              </v-layer>
            </v-stage>
          </div>
          <div class="summary-container">
            <OrderSummary
            :selectedGravestone="selectedGravestone"
            :selectedStonetype="selectedStonetype"
            :selectedSurfacetreatment="selectedSurfacetreatment"
            :selectedEdgetreatment="selectedEdgetreatment"
            :selectedStonesize="selectedStonesize"
            :selectedTexts="selectedTexts"
            :selectedFont="selectedFont"
            :selectedInscriptiondesign="selectedInscriptiondesign"
            :selectedDecorColor="selectedDecorColor"
            :selectedTextColor="selectedTextColor"
            :selectedDecors="selectedDecors"
            :reserverows="reserverows"
            :selectedAccessories="selectedAccessories"
            :textPriceInclVat="textPriceInclVat"
            :gravestonePriceInclVat="gravestonePriceInclVat"
            :percentageIncrease="percentageIncrease"

            />
            <div class="d-flex wrap">
              <div v-if="activeStep != 1" @click="chooseStep(activeStep + 1)" class="button-xlarge mb-1">Gå vidare till att skicka förfrågan</div>
              <div v-if="activeStep == 1" @click="validateOrder($refs.modalName.openModal); customer.accepted_conditions = false;" class="button-xlarge mb-1">Skicka förfrågan</div>
              <modal ref="modalName">
                <template v-slot:header>
                  <h4>Bekräfta förfrågan</h4>
                </template>
                <template v-slot:body>
                  <p class="mb-1">Jag vill skicka förfrågan gällande ny gravsten till Orsa Stenhuggeri och jag har tagit del av <a class="bold" target="_blank" href="https://www.orsasten.se/wp-content/uploads/2022/04/Villkor_köp_av_ny_gravsten_.pdf">villkoren</a>.</p>
                  <p class="mb-1">Vänligen notera att detta endast är en förfrågan som vi skall granska och om allt ser korrekt ut som görs denna automatiskt om till en beställning. </p>
                  <div class="input-container mb-1" style="flex-direction: row;">
                    <input class="mr-05" type="checkbox" id="accepted_conditions" v-model="customer.accepted_conditions">
                    <label for="accepted_conditions">Jag har läst och godkänner <a class="bold" target="_blank" href="https://www.orsasten.se/wp-content/uploads/2022/04/Villkor_köp_av_ny_gravsten_.pdf">villkoren</a>.</label>
                  </div>
                </template>
                <template v-slot:footer>
                  <div class="d-flex-row">
                    <div class="button secondary mr-05" @click="$refs.modalName.closeModal()">Avbryt</div>
                    <div :class="'button ml-05 ' + (customer.accepted_conditions == 'false' || customer.accepted_conditions == false || isLoading ? 'disabled' : '')" @click=" sendOrder($refs.modalName.closeModal);this.isLoading = true; ">Bekräfta</div>
                  </div>
                </template>
              </modal>
              <div class="d-flex" style="justify-content: space-between;">
                <div class="mr-2 button-small-reverse" style="cursor: pointer;" @click="resetAll()">Återställ</div>
                <div @click="generateSalesPdf()" class="button-small-reverse ">Skriv ut gravsten</div>
              </div>
            </div>
            <p id="warning_order" class="input-warning mt-1"></p>
            <div v-if="activeStep > 0" class="button-small-reverse mt-1" style="cursor: pointer;" @click="chooseStep(activeStep - 1)">Gå tillbaka</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DesignStep from './DesignStep.vue'
import OrderStep from './OrderStep.vue'
import OrderSummary from './OrderSummary.vue'
import Modal from "./Modal";
import jQuery from 'jquery'

import jsPDF from 'jspdf'
import 'jspdf-autotable'

import {
  base64fonts,
  getGravestonesAvailable,
  stonetypesAvailable,
  decorsAvailable,
  surfacetreatmentsAvailable,
  edgetreatmentsAvailable,
  inscriptiondesignsAvailable,
  colorsAvailable,
  getAccessoriesAvailable,
  logosAvailable
} from '../configuratorLibrary.js'


export default {
  name: 'GravestoneColumn',
  components: {
    DesignStep,
    OrderStep,
    OrderSummary,
    Modal
  },
  props: {
    chooseStep: Function,
    activeStep: Number,
    gravestone: Object,
    setFullScreenMessage: Function
  },
  data() {
    return {
      stageSize: {
        width: (3307 / 5),
        height: (3307 / 5),
      },
      isInit: false,
      isLoading: false,
      selectedShapeName: '',
      canvasBackgroundImg: null,
      gravestoneImage: '',
      orientation: 'standing',

      gravestonesAvailable: [],
      accessoriesAvailable: [],

      gravestones: {},
      selectedGravestone: {},

      withboard: 1,

      stonetypes: [],
      selectedStonetype: {},

      surfacetreatments: [],
      selectedSurfacetreatment: '',

      edgetreatments: [],
      selectedEdgetreatment: '',

      stonesizes: [],
      selectedStonesize: {},

      decors: {},
      selectedDecors: [],

      texts: [],
      selectedTexts: [],

      fonts: [],
      selectedFont: {},

      inscriptiondesigns: [],
      selectedInscriptiondesign: {},

      colors: [],
      selectedTextColor: {},
      selectedDecorColor: {},

      reserverows: null,

      accessories: [],
      selectedAccessories: [],

      defaultFontSize: 26,

      extraTextCount: 0,
      textPriceInclVat: 0,
      gravestonePriceInclVat: 0,

      percentageIncrease: 1,

      images: [],

      customer: {
        death_estate: '',
        customer_name: '',
        shipping_address: '',
        shipping_zip: '',
        shipping_city: '',
        billing_name: '',
        billing_phone: '',
        billing_email: '',
        billing_address: '',
        co_name: '',
        billing_city: '',
        billing_zip: '',
        customer_phone: '',
        customer_email: '',
        graveyard: '',
        gravestone_number: '',
        other_information: '',
        billing_same_as_customer: true,
        accepted_conditions: false

      },
      customer_errors: [],
      reseller: null,
      is_mobile: false
    }
  },
  async created() {

    this.gravestonesAvailable = await getGravestonesAvailable();
    this.accessoriesAvailable = await getAccessoriesAvailable();

    
    
    // console.log(jQuery(window).width());
    if (jQuery(window).width() <= 1024) {
      this.is_mobile = true;
      this.stageSize = {
        width: ((3307 / 5) * 0.5),
        height: ((3307 / 5) * 0.5)
      };
    } else {
      this.is_mobile = false;
      this.stageSize = {
        width: (3307 / 5),
        height: (3307 / 5)
      };
    }

    var queryString = window.location.search;
    var urlParams = new URLSearchParams(queryString);

    if (urlParams.has('reseller')) {
      this.validateReseller(urlParams.get('reseller'));
    } else {
      var self = this;
      
      self.initBase();
      setTimeout(function() {
        self.initGravestone();
      }, 500);
    }
  },
  watch: {
    customer: {
      handler() {
        localStorage.setItem('customer', JSON.stringify(this.customer));
      },
      deep: true,
    },
  },
  mounted() {
  },
  methods: {
    flipImage() {
      let stage = this.$refs.layer.getStage();

      stage.children.forEach((child, index) => {
        if (index != stage.children.length - 1 && (child.attrs.type == 'decor')) {
          console.log(child.attrs.y);
          child.scaleX(-child.attrs.scaleX);
        }
      });
    },
    validateReseller(encryptedReseller) {
      var self = this;

      let formData = new FormData();
      formData.append('action', 'validate_reseller');
      formData.append('reseller', encryptedReseller);

      this.axios.post(window.WP_OPTIONS.ajax_url, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          }
        })
        .then(response => {
          if (response.data.success) {
            this.reseller = response.data.data;
            this.customer = {
              id: (this.reseller['id'] ? this.reseller['id'] : ""),
              death_estate: '',
              customer_name: (this.reseller['name'] ? this.reseller['name'] : ""),
              shipping_address: (this.reseller['shipping_address'] ? this.reseller['shipping_address'] : ""),
              shipping_zip: (this.reseller['shipping_zip'] ? this.reseller['shipping_zip'] : ""),
              shipping_city: (this.reseller['shipping_city'] ? this.reseller['shipping_city'] : ""),
              billing_name: (this.reseller['billing_name'] ? this.reseller['billing_name'] : ""),
              billing_phone: (this.reseller['billing_phone'] ? this.reseller['billing_phone'] : ""),
              billing_email: (this.reseller['billing_email'] ? this.reseller['billing_email'] : ""),
              billing_address: this.reseller['billing_address'],
              co_name: '',
              billing_city: (this.reseller['billing_city'] ? this.reseller['billing_city'] : ""),
              billing_zip: this.reseller['billing_zip'],
              customer_phone: '',
              customer_email: (this.reseller['email'] ? this.reseller['email'] : ""),
              graveyard: '',
              gravestone_number: '',
              other_information: '',
              billing_same_as_customer: true,
              accepted_conditions: false
            }
            this.resetAll(this.customer);
          } else {
            this.setFullScreenMessage(false, 'Kunde inte identifiera återförsäljare/begravningsbyrå.');
          }
        })
        .catch(function(error) {
          console.log(error);
          self.setFullScreenMessage(false, 'Kunde inte identifiera återförsäljare/begravningsbyrå.');
        });
    },
    setImages(images) {
      this.images = images;
    },
    resetAll(customer = null) {
      this.selectedDecors = [];
      this.selectedTexts = [];

      if (!customer) {
        this.customer = {
          death_estate: '',
          customer_name: '',
          shipping_address: '',
          shipping_zip: '',
          shipping_city: '',
          billing_name: '',
          billing_phone: '',
          billing_email: '',
          billing_address: '',
          co_name: '',
          billing_city: '',
          billing_zip: '',
          customer_phone: '',
          customer_email: '',
          graveyard: '',
          gravestone_number: '',
          other_information: '',
          billing_same_as_customer: true,
          accepted_conditions: false
        };

        localStorage.removeItem("selectedGravestone");
        localStorage.removeItem("stonesizes");
        localStorage.removeItem("selectedStonesize");
        localStorage.removeItem("orientation");
        localStorage.removeItem("withboard");
        localStorage.removeItem("selectedAccessories");
        localStorage.removeItem("reserverows");
        localStorage.removeItem("selectedSurfacetreatment");
        localStorage.removeItem("selectedEdgetreatment");
        localStorage.removeItem("selectedStonetype");
        localStorage.removeItem("selectedDecors");
        localStorage.removeItem("selectedTexts");
        localStorage.removeItem("selectedFont");
        localStorage.removeItem("selectedInscriptiondesign");
        localStorage.removeItem("selectedTextColor");
        localStorage.removeItem("selectedDecorColor");
        localStorage.removeItem('percentageIncrease');
      }


      localStorage.removeItem("customer");
      if (customer !== null) {
        localStorage.setItem('customer', '{"death_estate":"","customer_name":"' + (this.reseller['name'] ? this.reseller['name'] : "") + '","shipping_address":"' + (this.reseller['shipping_address'] ? this.reseller['shipping_address'] : "") + '","shipping_zip":"' + (this.reseller['shipping_zip'] ? this.reseller['shipping_zip'] : "") + '","shipping_city":"' + (this.reseller['shipping_city'] ? this.reseller['shipping_city'] : "") + '","billing_address":"' + (this.reseller['billing_address'] ? this.reseller['billing_address'] : "") + '","billing_name":"' + (this.reseller['billing_name'] ? this.reseller['billing_name'] : "") + '","billing_phone":"' + (this.reseller['billing_phone'] ? this.reseller['billing_phone'] : "") + '","billing_email":"' + (this.reseller['billing_email'] ? this.reseller['billing_email'] : "") + '","co_name":"","billing_city":"' + (this.reseller['billing_city'] ? this.reseller['billing_city'] : "") + '","billing_zip":"' + (this.reseller['billing_zip'] ? this.reseller['billing_zip'] : "") + '","customer_phone":"","customer_email":"' + (this.reseller['email'] ? this.reseller['email'] : "") + '","graveyard":"","gravestone_number":"","other_information":"", "billing_same_as_customer":"true", "accepted_conditions":"false"}');
      }

      this.initBase();

      setTimeout(() => {
        this.initGravestone();
      }, 500);
    },
    initBase() {
      this.initFonts();
      this.percentageIncrease = (localStorage.getItem("percentageIncrease") === null ? 1 : parseFloat(localStorage.getItem('percentageIncrease')));
      this.selectedGravestone = (localStorage.getItem("selectedGravestone") === null ? this.gravestonesAvailable['standing'][34] : JSON.parse(localStorage.getItem('selectedGravestone')));
      this.stonesizes = (localStorage.getItem("stonesizes") === null ? this.selectedGravestone.dimensions : JSON.parse(localStorage.getItem('stonesizes')));
      this.selectedStonesize = (localStorage.getItem("selectedStonesize") === null ? this.selectedGravestone.dimensions[1] : JSON.parse(localStorage.getItem('selectedStonesize')));
      this.orientation = (localStorage.getItem("orientation") === null ? 'standing' : localStorage.getItem('orientation'));
      this.withboard = (localStorage.getItem("withboard") === null ? 0 : localStorage.getItem('withboard'));
      this.gravestones = this.gravestonesAvailable[this.orientation];

      let sizeIndex = this.selectedGravestone.dimensions.findIndex((g) => g.width === this.selectedStonesize.width && g.height === this.selectedStonesize.height);
      this.gravestonePriceInclVat = this.selectedGravestone.dimensions[sizeIndex].priceInclVat;

      this.decors = decorsAvailable;
      this.inscriptiondesigns = inscriptiondesignsAvailable;
      this.accessories = this.accessoriesAvailable;
      this.selectedAccessories = (localStorage.getItem("selectedAccessories") === null ? [] : JSON.parse(localStorage.getItem('selectedAccessories')));

      if (this.orientation == 'lying') {
        let accessorieIndex = this.selectedAccessories.findIndex((a) => a.name.includes('Blomlist'));

        if (!(accessorieIndex < 0)) {
          this.deleteAccessorie(this.selectedAccessories[accessorieIndex]);
        }
      }
      this.reserverows = (localStorage.getItem("reserverows") === null ? null : localStorage.getItem('reserverows'));

      this.surfacetreatments = surfacetreatmentsAvailable;
      this.selectedSurfacetreatment = (localStorage.getItem("selectedSurfacetreatment") === null ? surfacetreatmentsAvailable[0] : localStorage.getItem('selectedSurfacetreatment'));
      this.edgetreatments = edgetreatmentsAvailable;
      this.selectedEdgetreatment = (localStorage.getItem("selectedEdgetreatment") === null ? edgetreatmentsAvailable[1] : localStorage.getItem('selectedEdgetreatment'));

      let allStones = [];
      stonetypesAvailable.forEach((stone, i) => {
        allStones.push({
          id: i,
          name: stone,
        });
      });

      this.stonetypes = allStones;
      this.selectedStonetype = (localStorage.getItem("selectedStonetype") === null ? allStones[5] : JSON.parse(localStorage.getItem('selectedStonetype')));

      let allInscriptiondesigns = [];
      inscriptiondesignsAvailable.forEach((design, i) => {
        allInscriptiondesigns.push({
          id: i,
          name: design,
        });
      });

      this.inscriptiondesigns = allInscriptiondesigns;
      this.selectedInscriptiondesign = (localStorage.getItem("selectedInscriptiondesign") === null ? allInscriptiondesigns[0] : JSON.parse(localStorage.getItem('selectedInscriptiondesign')));


      let allColors = [];
      colorsAvailable.forEach((color, i) => {
        allColors.push({
          id: i,
          name: color,
        });
      });

      this.colors = allColors;
      this.selectedDecorColor = (localStorage.getItem("selectedDecorColor") === null ? allColors[1] : JSON.parse(localStorage.getItem('selectedDecorColor')));
      this.selectedTextColor = (localStorage.getItem("selectedTextColor") === null ? allColors[1] : JSON.parse(localStorage.getItem('selectedTextColor')));
      this.customer = (localStorage.getItem("customer") === null ? this.customer : JSON.parse(localStorage.getItem('customer')));

      this.isInit = true;
    },
    initGravestone() {
      let image = new window.Image();
      image.src = process.env.VUE_APP_IMAGE_FOLDER + this.selectedGravestone.file_name;
      image.onload = () => {
        // set image only when it is loaded
        this.canvasBackgroundImg = image;
        setTimeout(() => {
          if (localStorage.getItem("selectedDecors") !== null) {

            let selectedDecors = JSON.parse(localStorage.getItem('selectedDecors'));
            selectedDecors.forEach((decor) => {
              this.addDecor(decor);
            });

          } else {
            this.addDecor({
              file_name: "FH Duva 1.png",
              id: 7,
              name: "FH Duva 1",
              x: 278,
              y: 155,
              scaleX: 0.39,
              scaleY: 0.39,
            });
          }

          if (localStorage.getItem("selectedTexts") !== null) {
            let selectedTexts = JSON.parse(localStorage.getItem('selectedTexts'));
            selectedTexts.forEach((text) => {
              this.addText(text);
            });

          } else {
            this.addText({
              x: 232.5,
              y: 292,
              text: `Saknad och älskad
Namn Efternamn
1234 - 5678`,
            });
          }
        }, 500);
      };
    },

    initFonts() {
      let index = 0;
      let allFonts = [];

      Object.keys(base64fonts).forEach(function(fontname) {
        let formatedName = fontname.replace(/_/g, '-');

        allFonts.push({
          id: index,
          name: formatedName,
        });
        index = index + 1;
      });
      this.fonts = allFonts;
      this.selectedFont = (localStorage.getItem("selectedFont") === null ? this.fonts[3] : JSON.parse(localStorage.getItem('selectedFont')));
      this.selectFont(this.selectedFont);
    },
    setOrientation(e) {
      this.orientation = e.target.value;
      this.selectedGravestone = this.gravestonesAvailable[this.orientation][0];
      this.stonesizes = this.gravestonesAvailable[this.orientation][0].dimensions;
      this.selectedStonesize = this.gravestonesAvailable[this.orientation][0].dimensions[0];
      this.gravestones = this.gravestonesAvailable[this.orientation];

      if (this.orientation == 'lying' && this.selectedInscriptiondesign.name.includes('förgylld')) {
        this.selectedInscriptiondesign = this.inscriptiondesigns[0];
      }

      if (this.orientation == 'lying') {
        if (this.selectedInscriptiondesign.name.includes('förgylld')) {
          this.selectedInscriptiondesign = this.inscriptiondesigns[0];
        }

        let accessorieIndex = this.selectedAccessories.findIndex((a) => a.name.includes('Blomlist'));

        if (!(accessorieIndex < 0)) {
          this.deleteAccessorie(this.selectedAccessories[accessorieIndex]);
        }
      }

      this.selectGravestone(this.selectedGravestone);
    },
    randomID() {
      return '_' + Math.random().toString(36).substr(2, 9);
    },
    selectGravestone(gravestone) {
      this.selectedGravestone = gravestone;

      let index = gravestone.dimensions.findIndex((g) => g.width === this.selectedStonesize.width && g.height === this.selectedStonesize.height);
      let chosenStonesize = (index >= 0 ? gravestone.dimensions[index] : gravestone.dimensions[0]);

      this.stonesizes = gravestone.dimensions;
      this.selectStonesize(chosenStonesize);

      if (['1', '3', '4', '6'].includes(gravestone.name[0])) {
        this.selectedEdgetreatment = this.edgetreatments[0];
      } else {
        this.selectedEdgetreatment = this.edgetreatments[1];
      }

      let stage = this.$refs.canvasGravestone.getStage();
      let new_image = new window.Image();
      new_image.src = process.env.VUE_APP_IMAGE_FOLDER + gravestone.file_name;
      new_image.onload = () => {
        stage.image(new_image);
      };

      this.withboard = (gravestone.is_edging ? 1 : 0);

      localStorage.setItem('selectedGravestone', JSON.stringify(gravestone));
      localStorage.setItem('stonesizes', JSON.stringify(gravestone.dimensions));
      localStorage.setItem('orientation', this.orientation);
      localStorage.setItem('withboard', this.withboard);
      localStorage.setItem('selectedEdgetreatment', this.selectedEdgetreatment);
    },
    selectStonesize(size) {
      this.selectedStonesize = size;
      this.selectedAccessories.forEach((accessorie) => {
        if ("dimensions" in accessorie) {
          accessorie.priceInclVat = accessorie.dimensions[this.selectedStonesize.width].priceInclVat;
        }
      });

      this.gravestonePriceInclVat = size.priceInclVat;

      localStorage.setItem('selectedAccessories', JSON.stringify(this.selectedAccessories));
      localStorage.setItem('selectedStonesize', JSON.stringify(size));
    },
    getPercentageChange(oldNumber, newNumber) {
      var decreaseValue = oldNumber - newNumber;
      return (decreaseValue / oldNumber) * 100;
    },
    selectStonetype(stonetype) {
      if (stonetype.name == 'Svart diabas' || stonetype.name == 'Svart Labrador' || stonetype.name == 'Ljus Labrador' || stonetype.name == 'Älvdalskvartsit' || stonetype.name == 'Mörkgrå granit') {
        this.percentageIncrease = 1.2;

      } else if ((this.selectedStonetype.name == 'Svart diabas' || this.selectedStonetype.name == 'Svart Labrador' || this.selectedStonetype.name == 'Älvdalskvartsit' || stonetype.name == 'Mörkgrå granit') && (stonetype.name != 'Svart diabas' && stonetype.name != 'Svart Labrador' && stonetype.name != 'Ljus Labrador' && stonetype.name != 'Älvdalskvartsit' && stonetype.name != 'Mörkgrå granit')) {
        this.percentageIncrease = 1;
      } else {
        this.percentageIncrease = 1;
      }
      this.selectedStonetype = stonetype;

      localStorage.setItem('selectedStonetype', JSON.stringify(stonetype));
      localStorage.setItem('percentageIncrease', this.percentageIncrease);

    },
    selectSurfacetreatment(e) {
      let treatment = e.target.value;
      this.selectedSurfacetreatment = treatment;

      if (treatment.includes('Polerad') && this.selectedInscriptiondesign.name == 'Djupförsänkt' || (treatment.includes('Finhuggen') && this.selectedInscriptiondesign.name == 'Försänkt förgylld (äkta guld)')) {
        let colorIndex = this.colors.findIndex((c) => c.name === 'Svart');
        this.selectedDecorColor = this.colors[colorIndex];
        this.selectedTextColor = this.colors[colorIndex];

        this.selectedInscriptiondesign = this.inscriptiondesigns[0];
      }
      localStorage.setItem('selectedSurfacetreatment', treatment);
    },
    selectWithboard(e, isEdging) {
      let value = e.target.value;
      this.withboard = value;

      let gravestoneName = (isEdging ? this.selectedGravestone.name.replace(' B', '') : this.selectedGravestone.name + ' B');
      let index = this.gravestones.findIndex((g) => g.name === gravestoneName);

      this.selectGravestone(this.gravestones[index]);
      localStorage.setItem('withboard', value);
    },
    selectEdgetreatment(e) {
      let treatment = e.target.value;

      if (this.selectedGravestone.has_edge_treatment_option) {
        let index = this.gravestones.findIndex((g) => g.name === this.selectedGravestone.edge_treatment_option);

        if (index >= 0) {
          this.selectGravestone(this.gravestones[index]);
        }
      }
      this.selectedEdgetreatment = treatment;
      localStorage.setItem('selectedEdgetreatment', treatment);

    },
    selectInscriptiondesign(design) {
      this.selectedInscriptiondesign = design;

      if (!design.name.includes('Försänkt målad') ) {
        this.selectedTextColor = {};
        this.selectedDecorColor = {};

        localStorage.setItem('selectedTextColor', JSON.stringify({}));
        localStorage.setItem('selectedDecorColor', JSON.stringify({}));
      } else {
        let colorIndex = this.colors.findIndex((c) => c.name === 'Svart');
        this.selectedDecorColor = this.colors[colorIndex];
        this.selectedTextColor = this.colors[colorIndex];
      }

      if (design.name == 'Djupförsänkt') {
        let removeFonts = [];
        let fontIndex = this.fonts.findIndex((f) => f.name.includes('FH15'));
        removeFonts.push(fontIndex);
        fontIndex = this.fonts.findIndex((f) => f.name.includes('FH13'));
        removeFonts.push(fontIndex);

        if (this.selectedFont.name.includes('FH13') || this.selectedFont.name.includes('FH15')) {
          this.selectedFont = this.fonts[0];
        }

        removeFonts.forEach((index) => {
          this.fonts[index].display = 0;
        });
      } else {
        this.initFonts();
      }
      localStorage.setItem('selectedInscriptiondesign', JSON.stringify(design));
    },
    selectColor(type, color) {
      if (type == 'text') {
        this.selectedTextColor = color;
        localStorage.setItem('selectedTextColor', JSON.stringify(color));
      } else if (type == 'decor') {
        this.selectedDecorColor = color;
        localStorage.setItem('selectedDecorColor', JSON.stringify(color));
      }
    },
    selectFont(font) {
      this.selectedTexts.forEach((text) => {
        text.fontFamily = font.name;
      });
      this.selectedFont = font;
      localStorage.setItem('selectedFont', JSON.stringify(font));

    },
    selectAccessories(accessorie) {
      if (accessorie.name.includes('Blomlist') || accessorie.name.includes('Emperi')) {
        let accessorieIndex = this.selectedAccessories.findIndex((a) => a.name === accessorie.name);

        if (!(accessorieIndex < 0)) {
          return;
        }
      }

      this.selectedAccessories.push(accessorie);
      localStorage.setItem('selectedAccessories', JSON.stringify(this.selectedAccessories));

    },
    addDecor(decor) {
      let selectedDecors = this.selectedDecors;
      let new_image = new window.Image();
      new_image.src = process.env.VUE_APP_IMAGE_FOLDER + '/dekorer/' + decor.file_name;
      new_image.onload = () => {
        let imageWidth = new_image.width;
        let imageHeight = new_image.height;

        let positionX = (decor.x ? decor.x : 200);
        let positionY = (decor.y ? decor.y : 200);
        let scaleX = (decor.scaleX ? decor.scaleX : 1);
        let scaleY = (decor.scaleY ? decor.scaleY : 1);

        if (this.is_mobile && !decor.is_mobile) {
          positionX = positionX / 2;
          positionY = positionY / 2;
          scaleX = scaleX / 2;
          scaleY = scaleY / 2;
        } else if (!this.is_mobile && decor.is_mobile) {
          positionX = positionX * 2;
          positionY = positionY * 2;
          scaleX = scaleX * 2;
          scaleY = scaleY * 2;
        }
        let randomName = this.randomID();
        selectedDecors.push({
          rotation: (decor.rotation ? decor.rotation : 0),
          x: positionX,
          y: positionY,
          fillPatternImage: new_image,
          width: (decor.width ? decor.width : imageWidth),
          height: (decor.height ? decor.height : imageHeight),
          fillPatternScaleX: (decor.fillPatternScaleX ? decor.fillPatternScaleX : 1),
          fillPatternScaleY: (decor.fillPatternScaleY ? decor.fillPatternScaleY : 1),
          scaleX: scaleX,
          scaleY: scaleY,
          name: randomName,
          index: this.selectedDecors.length,
          display_name: (decor.display_name ? decor.display_name : decor.name),
          draggable: true,
          file_name: decor.file_name,
          type: 'decor',
          is_mobile: this.is_mobile,

        });
        this.selectedDecors = selectedDecors;
        localStorage.setItem('selectedDecors', JSON.stringify(selectedDecors));
      };
    },
    addText(text = {}) {
      let selectedTexts = this.selectedTexts;
      let fontSize = (text.fontSize ? text.fontSize : this.defaultFontSize);
      let positionX = (text.x ? text.x : 100);
      let positionY = (text.y ? text.y : 160);

      if (this.is_mobile && !text.is_mobile) {
        fontSize = fontSize / 2;
        positionX = positionX / 2;
        positionY = positionY / 2;
      } else if (!this.is_mobile && text.is_mobile) {
        fontSize = fontSize * 2;
        positionX = positionX * 2;
        positionY = positionY * 2;
      }

      let textObject = {
        x: positionX,
        y: positionY,
        fontSize: fontSize,
        text: (text.text ? text.text : ''),
        draggable: true,
        scaleX: (text.scaleX ? text.scaleX : 1),
        name: this.randomID(),
        index: this.selectedTexts.length,
        height: (text.height ? text.height : "auto"),
        type: (text.type ? text.type : 'text'),
        align: (text.align ? text.align : 'center'),
        fontFamily: this.selectedFont.name,
        lineHeight: 1.15,
        is_mobile: this.is_mobile,
      }

      selectedTexts.push(textObject);
      this.selectedTexts = selectedTexts;
      this.setTextPrice();
      localStorage.setItem('selectedTexts', JSON.stringify(this.selectedTexts));

    },
    updateText(text, action, e = null) {
      let currentText = this.selectedTexts.find((t) => t.name === text.name);

      if (action == 'text') {
        currentText.text = e.target.value;
      } else if (action == 'delete') {
        let textIndex = this.selectedTexts.findIndex((t) => t.name === text.name);
        this.selectedTexts.splice(textIndex, 1);
        this.resetTransformerNodes();

      } else if (action == 'align-left') {
        currentText.align = 'left';
      } else if (action == 'align-center') {
        currentText.align = 'center';
      } else if (action == 'align-right') {
        currentText.align = 'right';
      } else if (action == 'increase-size' && (currentText.fontSize < 50 || (currentText.fontSize < 25 && this.is_mobile))) {
        currentText.fontSize += 1;
      } else if (action == 'decrease-size' && (currentText.fontSize > 13 || (currentText.fontSize > 6 && this.is_mobile))) {
        currentText.fontSize -= 1;
      }

      this.setTextPrice();
      localStorage.setItem('selectedTexts', JSON.stringify(this.selectedTexts));
    },
    setTextPrice() {
      let totalTextCount = 0;
      this.selectedTexts.forEach((selectedText) => {
        let textCompressed = selectedText.text.replace(/\s/g, '');
        totalTextCount += textCompressed.length;
      });
      if (totalTextCount > 40) {
        this.textPriceInclVat = 90 * (totalTextCount - 40);
        this.extraTextCount = totalTextCount - 40;
      } else {
        this.textPriceInclVat = 0;
        this.extraTextCount = 0;
      }
    },
    updateReserverows(e) {
      this.reserverows = e.target.value;
      localStorage.setItem('reserverows', this.reserverows);
    },
    deleteDecor(decor) {

      let index = this.selectedDecors.findIndex((t) => t.name === decor.name);
      this.selectedDecors.splice(index, 1);
      this.resetTransformerNodes();
      localStorage.setItem('selectedDecors', JSON.stringify(this.selectedDecors));
    },
    flipDecor(decor) {
      let index = this.selectedDecors.findIndex((t) => t.name === decor.name);
      let stage = this.$refs.layer.getStage();

      stage.children.forEach((child, i) => {
        if (i != stage.children.length - 1 && (child.attrs.type == 'decor')) {
          if (child.attrs.name == decor.name) {
            var decor_src = '';

            if (child.attrs.file_name.includes('-mirror')) {
              decor_src = child.attrs.file_name.replace('-mirror', '');
            } else {
              decor_src = child.attrs.display_name + '-mirror.png';
            }

            let new_image = new window.Image();
            new_image.src = process.env.VUE_APP_IMAGE_FOLDER + '/dekorer/' + decor_src;
            new_image.onload = () => {
              child.fillPatternImage(new_image);
            }

            this.selectedDecors[index].file_name = decor_src;
          }
        }
      });
      localStorage.setItem('selectedDecors', JSON.stringify(this.selectedDecors));
    },

    deleteAccessorie(accessorie) {
      let index = this.selectedAccessories.findIndex((t) => t.name === accessorie.name);
      this.selectedAccessories.splice(index, 1);
      localStorage.setItem('selectedAccessories', JSON.stringify(this.selectedAccessories));
    },
    resetTransformerNodes() {
      let transformerNodeText = this.$refs.transformerText.getNode();
      let transformerNodeDecor = this.$refs.transformer.getNode();
      transformerNodeDecor.nodes([]);
      transformerNodeText.nodes([]);
    },

    formatPrice(x) {
      return x.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    },

    generateSalesPdf() {
      // First remove transformer nodes
      let transformerNodeText = this.$refs.transformerText.getNode();
      let transformerNodeDecor = this.$refs.transformer.getNode();
      transformerNodeText.nodes([]);
      transformerNodeDecor.nodes([]);

      let stage = this.$refs.layer.getStage();
      let standardWidth = 595.35;

      let pdf = new jsPDF({
        orientation: 'p',
        unit: 'pt',
        format: 'a4',
        precision: 10
      });

      let positionX = 0;
      let positionY = 0;
      let width = 300;
      let height = 300;
      let index = 1;

      positionX = (standardWidth - width) / 2;
      positionY = 100;

      var logoImage = new Image();
      logoImage.src = process.env.VUE_APP_IMAGE_FOLDER + 'orsa-sten-logga.png';
      var logoWidth = 333;
      var logoheight = 99;

      pdf.addImage(logoImage, 35, 25, logoWidth / 3, logoheight / 3, 15, 'MEDIUM');

      pdf.addImage(
        stage.toDataURL({ pixelRatio: 4 }),
        'PNG',
        positionX,
        positionY,
        width,
        height,
        index,
        'MEDIUM',
      );

      let fontSize = 10;

      pdf.setFontSize(fontSize);
      pdf.text( 'Bredd: ' + this.selectedStonesize['width'] + ' cm', standardWidth / 2, positionY - 10, {
          'align': 'center',
      });
      pdf.text( 'Höjd: ' + this.selectedStonesize['height'] + ' cm', positionX, positionY + (height / 2), {
          'align': 'center',
          'angle': 90
      });

      let body = [
        ['Gravsten:', this.selectedGravestone.name, this.formatPrice(this.gravestonePriceInclVat * this.percentageIncrease) + ' kr'],
        ['Stensort:', this.selectedStonetype.name, ''],
        ['Ytbehandling:', this.selectedSurfacetreatment, ''],
        ['Kantbehandling', this.selectedEdgetreatment, ''],
        ['Storlek:', 'Bredd: ' + this.selectedStonesize.width + ' cm, Höjd: ' + this.selectedStonesize.height + ' cm', ''],
        ['Teckensnitt:', this.selectedFont.name, ''],
        ['Textutförande:', this.selectedInscriptiondesign.name, ''],
      ];

      let decorsDisplay = this.selectedDecors.map(function(decor) {
        return decor['display_name'];
      });

      let chosenDecors = decorsDisplay.join(', ');

      if (this.selectedTextColor.name) {
        body.push(['Textfärg:', this.selectedTextColor.name, '']);
      }

      if (chosenDecors.length) {
        body.push(['Dekor:', chosenDecors]);
      }

      if (this.selectedDecorColor.name && chosenDecors.length) {
        body.push(['Dekorfärg:', this.selectedDecorColor.name, '']);
      }

      if (this.reserverows) {
        body.push(['Lämna rader till framtiden:', this.reserverows, '']);
      }

      if (this.selectedAccessories.length  ) {
        let self = this;
        this.selectedAccessories.map(function(accessorie) {
          body.push(['Tillval:', accessorie.name, (accessorie.name == 'Blomlist' ? self.formatPrice(accessorie.priceInclVat * self.percentageIncrease) : self.formatPrice(accessorie.priceInclVat) ) + ' kr']);
        });
      }

      if (this.textPriceInclVat > 0  ) {
          body.push(['Text över 40 tecken:', '', this.formatPrice(this.textPriceInclVat) + ' kr']);
      }

      let totalPriceAccessories = 0;
      this.selectedAccessories.forEach((accessories) => {
        totalPriceAccessories = totalPriceAccessories + (accessories.name == 'Blomlist' ? parseInt(accessories.priceInclVat * this.percentageIncrease) : parseInt(accessories.priceInclVat));
      });
      let accessoriesPriceInclVat = totalPriceAccessories;

      body.push(['Totalt Inkl moms:', '', this.formatPrice((this.gravestonePriceInclVat * this.percentageIncrease) + this.textPriceInclVat + accessoriesPriceInclVat) + ' kr']);

      pdf.autoTable({
        startY: positionY + height + 25,
        columnStyles: {
          0: { halign: 'left'},
          1: { halign: 'left'},
          2: { halign: 'right'},
        },
        headStyles :{fillColor : [12, 86, 76]},
        head: [['Information:', '', '']],
        body: body,
        showHead: "everyPage",
        didParseCell: function(cell, data)
        {
          console.log(data);
            if(cell.row.cells[0].text[0] == "Totalt Inkl moms:"){
                cell.cell.styles.fontStyle = 'bold';
            }
        },
      });
      var overlayImage = new Image();

      overlayImage.src = process.env.VUE_APP_IMAGE_FOLDER + '/dekorer/' + logosAvailable['Logo'][0]['file_name'];
      pdf.addImage(overlayImage, 150, 100, 300, 300, 20, 'MEDIUM');

      pdf.save('gravsten-orsa-sten.pdf');
    },

    generatePdf(asFile = false) {
      let stage = this.$refs.layer.getStage();
      let pdf = new jsPDF({
        orientation: 'p',
        unit: 'pt',
        format: [(this.is_mobile ? this.stageSize.height / 0.5 : this.stageSize.height), (this.is_mobile ? this.stageSize.width / 0.5 : this.stageSize.width)],
        precision: 10
      });

      let base64font = this.selectedFont.name.replace(/-/g, '_');
      pdf.setTextColor('#000000');
      pdf.addFileToVFS(this.selectedFont.name + ".ttf", base64fonts[base64font]);
      pdf.addFont(this.selectedFont.name + ".ttf", this.selectedFont.name, "normal");
      pdf.setFont(this.selectedFont.name);
      var indexRotation = [];
      stage.children.forEach((child, index) => {
        if (index != stage.children.length - 1 && (child.attrs.type == 'decor')) {
            var rotation = child.attrs.rotation;
            indexRotation[index] = {
              rotation: rotation,
              xPos: child.attrs.x,
              yPos: child.attrs.y
            };
            rotation = 0;
            const degToRad = Math.PI / 180
            const rotatePoint = ({x, y}, deg) => {
                const rcos = Math.cos(deg * degToRad), rsin = Math.sin(deg * degToRad);
                return {x: x*rcos - y*rsin, y: y*rcos + x*rsin};
            }
            //current rotation origin (0, 0) relative to desired origin - center (node.width()/2, node.height()/2)
            const topLeft = {x:-(child.width() * child.attrs.scaleX)/2, y:-(child.height()  * child.attrs.scaleX)/2};
            const current = rotatePoint(topLeft, child.rotation());
            const rotated = rotatePoint(topLeft, rotation);
            const dx = rotated.x - current.x, dy = rotated.y - current.y;
            child.rotation(rotation);
            child.x(child.x() + dx);
            child.y(child.y() + dy);
        }
      });
      stage.children.forEach((child, index) => {
        if (index != stage.children.length - 1 && (child.attrs.type == 'decor' || child.attrs.type == 'gravestone')) {
          let width = child.attrs.width * child.attrs.scaleX;
          let height = child.attrs.height * child.attrs.scaleX;
          let positionX = child.x();
          let positionY = child.y();

          width = (isNaN(width) ? child.width() : width);
          height = (isNaN(height) ? child.height() : height);

          if (this.is_mobile) {
            positionX = positionX * 2;
            positionY = positionY * 2;
            width = width * 2;
            height = height * 2;
          }

          var rotation = 0;
          if (child.attrs.type != 'gravestone') {
            rotation = indexRotation[index].rotation;
            const degToRad = Math.PI / 180;
            const rotatePoint = ({x, y}, deg) => {
                const rcos = Math.cos(deg * degToRad), rsin = Math.sin(deg * degToRad);
                return {x: x*rcos - y*rsin, y: y*rcos + x*rsin};
            }
            //current rotation origin (0, 0) relative to desired origin - center (node.width()/2, node.height()/2)
            const topLeft = {x:-(width)/2, y:-(height)/2};
            const current = rotatePoint(topLeft, rotation * -1);
            const rotated = rotatePoint(topLeft, 0);
            const dx = rotated.x - current.x, dy = rotated.y - current.y;
            positionX = (positionX - dx);
            positionY = (positionY + dy);
          }
          pdf.addImage(
            child.toDataURL({ pixelRatio: 4 }),
            'PNG',
            positionX,
            positionY,
            width,
            height,
            index,
            'MEDIUM',
            rotation * -1
          );
          if (child.attrs.type != 'gravestone') {
            rotation = indexRotation[index].rotation;
            const degToRad = Math.PI / 180
            const rotatePoint = ({x, y}, deg) => {
                const rcos = Math.cos(deg * degToRad), rsin = Math.sin(deg * degToRad);
                return {x: x*rcos - y*rsin, y: y*rcos + x*rsin};
            }
            //current rotation origin (0, 0) relative to desired origin - center (node.width()/2, node.height()/2)
            const topLeft = {x:-(child.attrs.width * child.attrs.scaleX)/2, y:-(child.attrs.height * child.attrs.scaleX)/2};
            const current = rotatePoint(topLeft, child.rotation());
            const rotated = rotatePoint(topLeft, rotation);
            const dx = rotated.x - current.x, dy = rotated.y - current.y;
            child.rotation(rotation);
            child.x(child.x() + dx);
            child.y(child.y() + dy);
          }
        }
      });
      // first add texts
      stage.find('Text').forEach((text) => {
        let fontSize = text.fontSize();
        let positionX = text.x();
        let positionY = text.y();
        let width = text.width();
        if (this.is_mobile) {
          fontSize = fontSize * 2;
          positionX = positionX * 2;
          positionY = positionY * 2;
          width = width * 2;
        }
        pdf.setFontSize(fontSize);

        let adjustX = (width / 2);
        if (text.align() == 'left') {
          adjustX = 0;
        } else if (text.align() == 'right') {
          adjustX = width;
        }

        pdf.text(text.text(), positionX + adjustX, positionY + (fontSize * (2 - 1.15)), {
          'align': text.align(),
        });

      });


      if (asFile) {
        let pdfFile = btoa(pdf.output());
        // var blob = pdf.output('blob');
        return pdfFile;
      }

      pdf.save('canvas.pdf');
    },
    handleTransformEnd(e) {
      // shape is transformed, let us save new attrs back to the node
      // find element in our state
      let rect = '';
      if (e.target.attrs.type == 'text') {
        rect = this.selectedTexts.find((r) => r.name === this.selectedShapeName);
      } else {
        rect = this.selectedDecors.find((r) => r.name === this.selectedShapeName);
      }

      // update the state
      rect.x = e.target.x();
      rect.y = e.target.y();
      rect.rotation = e.target.rotation();
      rect.scaleX = e.target.scaleX();
      rect.scaleY = e.target.scaleY();
    },
    handleStageMouseUp() {
      let stage = this.$refs.layer.getStage();

      stage.children.forEach((child, index) => {
        if (index != stage.children.length - 1 && (child.attrs.type == 'decor')) {
          let decorIndex = this.selectedDecors.findIndex((d) => d.name === child.attrs.name);
          this.selectedDecors[decorIndex] = child.attrs;
        }
      });
      // first add texts
      stage.find('Text').forEach((text) => {
        let textIndex = this.selectedTexts.findIndex((t) => t.name === text.attrs.name);
        let selectedTexts = this.selectedTexts;

        selectedTexts[textIndex].x = text.attrs.x;
        selectedTexts[textIndex].y = text.attrs.y;

        this.selectedTexts = selectedTexts;
      });
      localStorage.setItem('selectedDecors', JSON.stringify(this.selectedDecors));
      localStorage.setItem('selectedTexts', JSON.stringify(this.selectedTexts));
    },
    handleStageMouseDown(e) {
      if (!e.target.attrs) { return; }
      let type = e.target.attrs.type;

      // clicked on stage - clear selection
      if (e.target === e.target.getStage()) {
        this.selectedShapeName = '';
        this.updateTransformer('');
        // this.updateTransformer('text');
        return;
      }

      // clicked on transformer - do nothing
      const clickedOnTransformer =
        e.target.getParent().className === 'Transformer';
      if (clickedOnTransformer) {
        return;
      }

      // find clicked rect by its name
      const name = e.target.name();
      let rect = '';
      if (e.target.attrs.type == 'text') {
        rect = this.selectedTexts.find((r) => r.name === name);
      } else {
        rect = this.selectedDecors.find((r) => r.name === name);
      }
      if (rect) {
        this.selectedShapeName = name;
      } else {
        this.selectedShapeName = '';
      }

      this.updateTransformer(type);
    },
    updateTransformer(type) {
      // here we need to manually attach or detach Transformer node
      let transformerNode = null;
      let transformerNodeText = this.$refs.transformerText.getNode();
      let transformerNodeDecor = this.$refs.transformer.getNode();

      if (type == 'text') {
        transformerNode = transformerNodeText;
      } else {
        transformerNode = transformerNodeDecor;
      }
      const stage = transformerNode.getStage();
      const { selectedShapeName } = this;
      const selectedNode = stage.findOne('.' + selectedShapeName);


      if (selectedNode) {
        if (type == 'text') {
          transformerNodeDecor.nodes([]);

          let textIndex = this.selectedTexts.findIndex((t) => t.name === selectedNode.attrs.name);
          let selectedTexts = this.selectedTexts;

          selectedTexts[textIndex].x = selectedNode.attrs.x;
          selectedTexts[textIndex].y = selectedNode.attrs.y;

          this.selectedTexts = selectedTexts;

        } else if (type == 'decor') {
          transformerNodeText.nodes([]);

          let decorIndex = this.selectedDecors.findIndex((d) => d.name === selectedNode.attrs.name);
          this.selectedDecors[decorIndex] = selectedNode.attrs;

        } else if (type == 'gravestone') {
          transformerNodeText.nodes([]);
          transformerNodeDecor.nodes([]);

        }
        // attach to another node
        transformerNode.nodes([selectedNode]);
      } else {
        // remove transformer
        transformerNodeDecor.nodes([]);
        transformerNodeText.nodes([]);

      }

      localStorage.setItem('selectedDecors', JSON.stringify(this.selectedDecors));
      localStorage.setItem('selectedTexts', JSON.stringify(this.selectedTexts));
    },

    validateOrder(opt_callback) {
      this.isLoading = false;
      let validated = true;
      let errorFields = [];
      if (!this.customer.death_estate.length) {
        errorFields.push('death_estate');
        validated = false;
      }
      if (!this.customer.customer_name.length) {
        errorFields.push('customer_name');
        validated = false;
      }
      if (!this.customer.shipping_address.length) {
        errorFields.push('shipping_address');
        validated = false;
      }
      if (!this.customer.shipping_zip.length) {
        errorFields.push('shipping_zip');
        validated = false;
      }
      if (!this.customer.shipping_city.length) {
        errorFields.push('shipping_city');
        validated = false;
      }
      if (!this.customer.customer_phone.length) {
        errorFields.push('customer_phone');
        validated = false;
      }
      if (!this.validEmail(this.customer.customer_email)) {
        errorFields.push('customer_email');
        validated = false;
      }

      if (!this.customer.billing_same_as_customer) {
        if (!this.customer.billing_address.length) {
          errorFields.push('billing_address');
          validated = false;
        }
        if (!this.customer.billing_zip.length) {
          errorFields.push('billing_zip');
          validated = false;
        }
        if (!this.customer.billing_city.length) {
          errorFields.push('billing_city');
          validated = false;
        }
        if (!this.customer.billing_name.length) {
          errorFields.push('billing_name');
          validated = false;
        }
        if (!this.customer.billing_phone.length) {
          errorFields.push('billing_phone');
          validated = false;
        }
        if (!this.validEmail(this.customer.billing_email)) {
          errorFields.push('billing_email');
          validated = false;
        }
      }

      if (!this.customer.graveyard.length) {
        errorFields.push('graveyard');
        validated = false;
      }

      this.customer_errors = errorFields;

      var callback = opt_callback || function() {};
      this.isLoading = false;

      if (validated) {
        callback();
        return validated;
      }

      return validated;
    },
    sendOrder(opt_callback) {
      if (this.isLoading) {
        return;
      }

      let validated = this.validateOrder;

      if (!validated || !this.customer.accepted_conditions) {
        console.log("Alla fält är EJ ifyllda");

      } else {
        let newOrder = this.customer;

        newOrder['gravestone_orientation'] = (this.orientation == 'standing' ? 'Stående' : 'Liggande');
        newOrder['gravestone'] = this.selectedGravestone.name;
        newOrder['gravestone_type'] = this.selectedStonetype.name;
        newOrder['surfacetreatment'] = this.selectedSurfacetreatment;
        newOrder['edgetreatment'] = this.selectedEdgetreatment;
        newOrder['id'] = (this.reseller !== null ? this.reseller.id : null);

        newOrder['gravestone_size'] = this.selectedStonesize.width + ' x ' + this.selectedStonesize.height;
        newOrder['texts'] = this.selectedTexts;
        newOrder['fontface'] = this.selectedFont.name;
        newOrder['inscription_design'] = this.selectedInscriptiondesign.name;

        newOrder['decor_color'] = this.selectedDecorColor.name;
        newOrder['inscription_color'] = this.selectedTextColor.name;

        newOrder['inscription_reserved_rows'] = this.reserverows;
        newOrder['accessories'] = this.accessories;

        let decorsDisplay = this.selectedDecors.map(function(decor) {
          return decor['display_name'];
        });

        newOrder['decors'] = decorsDisplay.join(', ');

        let textsDisplay = this.selectedTexts.map(function(text) {
          return text['text'];
        });

        newOrder['inscription'] = textsDisplay.join('\n\n');
        var gravestonePriceInclVat = this.gravestonePriceInclVat * this.percentageIncrease;

        let orderItems = [];
        orderItems.push({
          'description': 'Ny gravsten',
          'price_excl_vat': this.calculateExclvat(gravestonePriceInclVat, 25),
          'price_incl_vat': gravestonePriceInclVat.toFixed(2),
          'qty': 1,
          'vat': 25,
          'discount': null
        });
        newOrder['order_items'] = orderItems;

        if (this.textPriceInclVat > 0) {
          orderItems.push({
            'description': 'Text över 40 tecken',
            'price_excl_vat': this.calculateExclvat('90', 25),
            'price_incl_vat': '90.00',
            'qty': this.extraTextCount,
            'vat': 25,
            'discount': null
          });
        }

        let orderAccessories = {};

        if (this.selectedAccessories.length) {
          this.selectedAccessories.forEach((accessories) => {
            if (accessories.name in orderAccessories) {
              orderAccessories[accessories.name].qty = orderAccessories[accessories.name].qty + 1;
            } else {
              var accessoriePriceInclVat = (accessories.name == 'Blomlist' ? accessories.priceInclVat * this.percentageIncrease : accessories.priceInclVat)
              orderAccessories[accessories.name] = {
                'description': accessories.name,
                'price_excl_vat': this.calculateExclvat(accessoriePriceInclVat, 25),
                'price_incl_vat': accessoriePriceInclVat.toFixed(2),
                'qty': 1,
                'vat': 25,
                'discount': null
              };
            }
          });

          for (const key in orderAccessories) {
            orderItems.push({
              'description': orderAccessories[key].description,
              'price_excl_vat': orderAccessories[key].price_excl_vat,
              'price_incl_vat': orderAccessories[key].price_incl_vat,
              'qty': orderAccessories[key].qty,
              'vat': orderAccessories[key].vat,
              'discount': orderAccessories[key].discount
            });
          }
        }

        let formData = new FormData();
        formData.append('action', 'create_order');
        let graveStonePDF = this.generatePdf(true);
        let allImages = [];

        formData.append('order', JSON.stringify(newOrder));
        formData.append('pdf', graveStonePDF);

        if (this.images.length > 0) {
          for (var i = 0; i < this.images.length; i++) {
            let image = this.images[i];
            allImages.push(image);
          }
          formData.append('images', JSON.stringify(allImages));
        }

        var callback = opt_callback || function() {};

        this.axios.post(window.WP_OPTIONS.ajax_url, formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            }
          })
          .then(response => {

            if (response.data.success) {
              // console.log("hej1");
              console.log(response.data);
              let element = document.getElementById('warning_order');
              element.innerHTML = "";
              element.classList.remove("active");
              console.log(response);
              callback();
              this.setFullScreenMessage();
            } else {
              let element = document.getElementById('warning_order');
              let textContent = '<span>Felmeddelande: ' + response.data.message + '</span>';

              if (response.data.data) {
                response.data.data.forEach((errorMessage) => {
                  textContent = textContent + '<br><span>' + errorMessage + '</span>';
                });
              }

              element.innerHTML = textContent;
              element.classList.add("active");
              callback();
            }

            // this.resetAll();
          })
          .catch(function(error) {
            console.log(error);

            let element = document.getElementById('warning_order');
            let textContent = '<span>Felkod: ' + error.response.status + ' (' + error.response.statusText + ')</span>';

            if (error.response.data.data) {
              error.response.data.data.forEach((errorMessage) => {
                textContent = textContent + '<br><span>' + errorMessage + '</span>';
              });
            }

            element.innerHTML = textContent;
            error.response.data.message;
            element.classList.add("active");
            callback();
          });
      }
    },
    calculateExclvat(incl_vat, vat_percentage) {
      return parseFloat((parseFloat(incl_vat) / (1 + (vat_percentage / 100)))).toFixed(2);
    },
    validEmail(email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }
  },
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.design-choice {
  min-height: 400px;
}

.konvajs-content {
  margin: 0 auto !important;
}

.stone-size-display {
  border-bottom: 1px solid;
  width: 130px;
  font-weight: bold;
}

.stone-size-display.side {
  position: absolute;
  /*left: 0;*/
  left: -80px;
  font-weight: bold;
  transform: rotate(270deg);
}

.order-summary-container span {
  font-style: italic;
}

.overflow-hidden {
  overflow: hidden;
}

.summary-container {
  min-width: 550px;
}

@media only screen and (max-width: 1024px) {
  .design-choice .d-flex:first-of-type {
    flex-direction: column;
  }

  .summary-container {
    min-width: auto;
    padding-bottom: 3rem;
  }
}
</style>